<i18n
  src="@/locales/views/agro_exporter/production/query_container_export/show_exportation.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('show_process_exportations')"
    :params="{ agro_exporter_process_id: agro_exporter_process_id }"
  />

  <template v-if="load_data_general">
    <bread-crumbs :labels="[module_name, agro_exporter_process.name]" />
    <div class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>

        <div class="panel-body">
          <div class="space-y-8 divide-y divide-gray-200" v-if="exportation">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  <template v-if="exportation.exportation_type_id == 0">
                    {{ $t("model.exportation.booking_code_0") }}
                  </template>
                  <template v-else-if="exportation.exportation_type_id == 1">
                    {{ $t("model.exportation.booking_code_1") }}
                  </template>
                </dt>
                <dd class="content-data">
                  {{ exportation.booking_code }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.exportation_type") }}
                </dt>
                <dd class="content-data">
                  <exportation-type
                    :exportation_type_id="exportation.exportation_type_id"
                  />
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.week") }}
                </dt>
                <dd class="content-data">
                  {{ exportation.week }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.status") }}
                </dt>
                <dd class="content-data">
                  <exportation-status :status_id="exportation.status_id" />
                </dd>
              </div>
            </div>
            <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-6">
                <div
                  class="table-first-container"
                  v-if="exportation.containers?.length > 0"
                >
                  <div class="table-second-container">
                    <div class="table-third-container">
                      <table class="table">
                        <thead class="table-header">
                          <tr>
                            <th scope="col" class="table-header-cell">
                              {{ $t("model.exportation.container") }}
                            </th>
                            <th scope="col" class="table-header-cell">
                              {{ $t("model.container.packing_house") }}
                            </th>
                            <th scope="col" class="table-header-cell">
                              {{ $t("model.container.producers") }}
                            </th>
                            <th scope="col" class="table-header-cell">
                              {{ $t("model.container.customer") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody class="table-body">
                          <tr
                            class="table-row"
                            v-for="container in exportation.containers"
                            :key="container.id"
                          >
                            <td class="table-cell">
                              {{ container.container_code }}
                            </td>
                            <td class="table-cell">
                              {{ container.packing_house_names.join(", ") }}
                            </td>
                            <td class="table-cell"></td>
                            <td class="table-cell">
                              {{ container.customer?.name }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <alert-warning
                  v-else
                  :warning_data="{
                    title: $t('labels.not_containers')
                  }"
                />
              </div>
            </div>

            <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.origin_export") }}
                </dt>
                <dd class="content-data">
                  {{ exportation.origin_export?.name }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.destination_export") }}
                </dt>
                <dd class="content-data">
                  {{ exportation.destination_export?.name }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.departured_at") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(exportation.departured_at) }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.arrived_at") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(exportation.arrived_at) }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.shipping_line") }}
                </dt>
                <dd class="content-data">
                  {{ exportation.shipping_line?.name }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.ship") }}
                </dt>
                <dd class="content-data">
                  {{ exportation.ship }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.dam_code") }}
                </dt>
                <dd class="content-data">
                  {{ exportation.dam_code }}
                </dd>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div class="panel-footer-actions">
            <button
              type="button"
              @click.prevent="downloadReportExportation()"
              class="btn-white"
            >
              <i class="fa-solid fa-file-excel"></i>
              <span class="space-icon"></span
              >{{ $t("labels.exportation_report_button") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="my-8" v-if="exportation_attachments.length > 0">
      <div class="flex justify-between mt-8 mb-2">
        <h3 class="items-center">
          <div class="panel-header-title">Adjuntos</div>
        </h3>
      </div>
      <div class="mt-8 flex flex-col">
        <div class="table-first-container">
          <div class="table-second-container">
            <div class="table-third-container">
              <table class="table">
                <thead class="table-header">
                  <tr>
                    <th scope="col" class="table-header-cell">
                      {{
                        $t(
                          "model.exportation.exportation_attachments.exporter_process_exportation_file"
                        )
                      }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{
                        $t(
                          "model.exportation.exportation_attachments.exportation_attach"
                        )
                      }}
                    </th>
                    <th scope="col" class="table-header-cell"></th>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <tr
                    class="table-row"
                    v-for="attachment in exportation_attachments"
                    :key="attachment.id"
                  >
                    <td class="table-cell">
                      {{ attachment.exporter_process_exportation_file.name }}
                    </td>
                    <td class="table-cell-main">
                      {{ attachment.exportation_attach.blob.filename }}
                    </td>
                    <td class="table-cell-action">
                      <i
                        class="fa-solid fa-spinner"
                        v-if="attachment.requesting"
                      ></i>
                      <template v-else>
                        <span class="space-actions hidden sm:inline"></span>
                        <button
                          class="btn-white inline-flex"
                          @click.prevent="
                            downloadExportationAttachment(attachment)
                          "
                        >
                          <i
                            :class="[
                              'fa-solid ',
                              attachment.downloading
                                ? ' fa-sppiner'
                                : ' fa-download'
                            ]"
                          ></i>
                        </button>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/production/query_container_export/show_exportation.js";
import ExportationStatus from "@/components/views/agro_exporter/production/shared/exportation/ExportationStatus.vue";
import ExportationType from "@/components/views/agro_exporter/production/shared/exportation/ExportationType.vue";

export default {
  name: "AEProductionQueryContainerExportNewContainer",
  components: {
    ExportationStatus,
    ExportationType
  },
  props: ["agro_exporter_process_id", "exportation_id", "agro_exporter_id"],
  data() {
    return {
      proc_button_destroy: false,
      load_data_general: false,
      agro_exporter_process: {},
      exportation: null,
      exportation_attachments: []
    };
  },
  methods: {
    fetchExportation: async function () {
      let response = await Requester.fetchExportation(this.exportation_id);
      this.exportation = response.data;
      this.load_data_general = true;
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchExportationAttachments: async function () {
      let response = await Requester.fetchExportationAttachments(
        this.exportation_id
      );

      this.exportation_attachments = response.data.map(
        exportation_attachment => {
          return {
            ...exportation_attachment,
            downloading: false
          };
        }
      );
    },
    exportationAttachments: function (exporter_process_exportation_file_id) {
      return this.exportation_attachments.filter(
        exportation_attachment =>
          exportation_attachment.exporter_process_exportation_file_id ===
          exporter_process_exportation_file_id
      );
    },
    goToShowProcess: function () {
      this.$router.push({
        name: this.routeName("show_process_exportations"),
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id
        }
      });
    },
    downloadReportExportation: async function () {
      this.downloading = true;
      try {
        var response = await Requester.downloadExportationRepXlsx(
          this.exportation_id
        );
        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          "Sem_" +
            this.exportation.week +
            "_Reporte_de_Exportacion_" +
            this.exportation.booking_code +
            ".xlsx"
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
      this.downloading = false;
    },
    downloadExportationAttachment: async function (exportation_attachment) {
      exportation_attachment.downloading = true;
      try {
        var response = await Requester.downloadExportationAttachment(
          this.exportation_id,
          exportation_attachment.id
        );
        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          exportation_attachment.exportation_attach.blob.filename
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
      exportation_attachment.downloading = false;
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => {
        this.fetchAgroExporterProcess();
        this.fetchExportation();
        this.fetchExportationAttachments();
      })
    );
  }
};
</script>
